var initHeaderNavigation = function () {
    var header = $('#header');
    var navigation = $('.header_menu_nav');
    var navigation_bg = $('#header_menu_bg');
    header.on("mouseenter",function(){
        $(this).css('background','#fff');
    });
    header.on("mouseleave",function  () {
        $(this).css('background', '');
        navigation_bg.slideUp();
        navigation.find('ul').fadeOut();
    });
    navigation.find('> li > a').each(function () {
        $(this).on("mouseenter",function(){
            navigation_bg.slideDown();
            navigation.find('ul').fadeIn();
        });
    });
    function addHeaderBg() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            header.addClass('header_on');
        } else {
            header.removeClass('header_on');
        }
    }

    $(window).scroll(function() {
        addHeaderBg();
    });
};

jQuery(document).ready(function($){
    initHeaderNavigation();
});